import { useContext } from 'react';
import { AdminBoardFilterContext } from '../components/UnifiedGeoRoleFilter';

export function adminScopeTerms(view = 'corporate') {
  const occupant = view === 'valet' ? 'Resident' : view === 'cleaners' ? 'Tenant' : 'Resident/Tenant';
  const occupants = view === 'valet' ? 'Residents' : view === 'cleaners' ? 'Tenants' : 'Residents/Tenants';
  const staff = view === 'valet' ? 'Valet staff' : view === 'cleaners' ? 'Cleaners' : 'Field staff';
  const properties = view === 'valet' ? 'Multifamily properties' : view === 'cleaners' ? 'Commercial properties' : 'All properties';
  // Only apply to authored UI labels, never names, records, or identifiers.
  const text = value => typeof value !== 'string' ? value : value
    .replace(/\b(?:residents\s*\/\s*tenants|residents|tenants)\b/gi, occupants)
    .replace(/\b(?:resident\s*\/\s*tenant|resident|tenant)\b/gi, occupant)
    .replace(/\b(?:field staff|staffing agents|field agents)\b/gi, staff);
  return { view, occupant, occupants, staff, properties, text };
}

export function useAdminScopeTerms() {
  const filter = useContext(AdminBoardFilterContext);
  const terms = adminScopeTerms(filter?.view_as);
  return filter ? terms : { ...terms, text: value => value };
}